import { render, staticRenderFns } from "./showMyTeam.vue?vue&type=template&id=3616fff4"
import script from "./showMyTeam.vue?vue&type=script&lang=js"
export * from "./showMyTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports